module.exports = __webpack_public_path__ + "static/media/goods8.faf37ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods8.png
// module id = 1200
// module chunks = 0